import type { ReactNode } from 'react'

export default function SquiggleAccent({
  children,
  className = '',
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <em className={`preview-squiggle-trigger italic ${className}`}>
      {children}
    </em>
  )
}
